<div class="container pa-15">
  <div class="row">
    <div class="col-12">
      <app-property-infos></app-property-infos>
    </div>
  </div>
</div>
